import { z } from 'zod';
import { FlowDurationUnits } from '../../../duration/duration.js';
import { FlowDurationSchemaWithMax } from '../../../duration/withMax.js';
import { FlowRunExecutionMode } from '../../../flowRun/executionMode.js';
import { BaseFlowBlockSchema } from '../block.js';
import { FlowBlockType } from '../type.js';
export const FlowHl7BlockSchema = BaseFlowBlockSchema.extend({
    type: z.literal(FlowBlockType.Hl7),
    config: z.object({
        message: z.string(),
        destinationDatastore: z.string({ message: 'Destination Datastore is required' }),
        runMode: z
            .enum(
        /* eslint-disable-next-line @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
        FlowRunExecutionMode)
            .optional()
            .default(
        /* eslint-disable-next-line @typescript-eslint/no-deprecated -- the block schema must reference the deprecated run-execution mode while it remains supported */
        FlowRunExecutionMode.Live),
        timeout: FlowDurationSchemaWithMax({
            pathName: 'timeout',
            max: { value: 3, units: FlowDurationUnits.Minutes },
        }),
    }),
});
//# sourceMappingURL=config.js.map